import cls from "./googleMap.module.scss";
import React, {ReactNode, useEffect, useState} from "react";

const GoogleMap = () => {
    const [showIframe, setShowIframe] = useState<ReactNode | null>(null);
    useEffect(() => {
        const handleScroll = () => {
            if (!showIframe) {
                setShowIframe(
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.048217020971!2d44.505611!3d40.172600!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4041f1e8173d8bf5%3A0x0!2s26a%20Movses%20Khorenatsi%20Street!5e0!3m2!1sen!2sus!4v<timestamp>"
                        width="100%"
                        height="100%"
                        loading="lazy"
                    />
                )
            }
        }
        if (!showIframe) {
            window.addEventListener("scroll", handleScroll)
        } else {
            window.removeEventListener("scroll", handleScroll)
        }
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])
    return (
        <div className={cls["footer-google_map"]}>
            {showIframe}
        </div>
    )
}

export default GoogleMap;